import {
  differenceInMinutes,
  // formatDuration,
  // intervalToDuration,
  // milliseconds,
} from "date-fns";
import {
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import React, { useState, useEffect, useContext } from "react";
import TodosDrawer from "../components/TodosDrawer";
import { todosRef } from "../firebase";
import { AuthContext } from "./AuthProvider";
import { SettingsContext } from "./SettingsProvider";

const TodosContext = React.createContext(null);

const TodosProvider = (props) => {
  const [todos, setTodos] = useState([]);
  const { startDate } = useContext(SettingsContext);
  const [loading, setLoading] = useState(true);
  const [todosDrawer, setTodosDrawer] = useState(false);

  const { userData } = useContext(AuthContext);

  function sortTodos(data) {
    // sorts todos to be unmarked first
    let tempData = [...data];
    tempData.sort((a, b) => {
      return a?.isComplete - b?.isComplete;
    });
    return tempData;
  }

  async function deleteExpired(data) {
    // Delete completed notes over specified time limit (in minutes)
    let now = Date.now();
    let hours24 = 1440;
    await data.forEach(async (todo) => {
      if (todo?.markedCompletedOn) {
        // let duration = intervalToDuration({
        //   start: todo.markedCompletedOn,
        //   end: Date.now(),
        // });

        let diffInMinutes = differenceInMinutes(now, todo?.markedCompletedOn);

        // If todo has been marked complete for over 24hours, delete it.
        if (diffInMinutes > hours24) {
          await deleteDoc(doc(todosRef, todo.uid));
        }
      }
    });

    // console.log("What is being returned", data);
    return data;
  }

  useEffect(() => {
    if (!userData.uid) {
      return;
    }

    // Only listen and bring in todos that:
    // - have been created by someone who is contained in the user's associated accounts.

    let q = query(
      todosRef,
      where("createdBy", "in", userData.associatedAccounts),
      orderBy("created", "desc")
    );

    const unsubscribeFromTodos = onSnapshot(q, (doc) => {
      let todosData = [];

      doc.forEach((todo) => {
        todosData.push(todo.data());
      });

      setLoading(false);

      deleteExpired(todosData);
      let sortedTodos = sortTodos(todosData);

      setTodos([...sortedTodos]);
      // setTodos([...todosData]);
    });

    return () => {
      // console.log("un subbing from timesheets");
      unsubscribeFromTodos();
    };
  }, [setTodos, startDate, userData.associatedAccounts, userData.uid]);

  function toggleTodos(open) {
    return (event) => {
      setTodosDrawer(open);
    };
  }

  return (
    <TodosContext.Provider
      value={{
        todos: todos,
        setTodos,
        loading,
        toggleTodosDrawer: setTodosDrawer,
      }}
    >
      <TodosDrawer todosDrawer={todosDrawer} toggleTodos={toggleTodos} />
      {props.children}
    </TodosContext.Provider>
  );
};

export { TodosProvider, TodosContext };
